module.exports = __webpack_public_path__ + "img/9422343.aa88b7c5.png";